import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import env from 'src/env';
import MainLayout from 'src/Components/Pages/MainLayout';
import sparkUpLanguageUrl from 'src/utils/sparkUpLanguageUrl';
import { useQuery } from '@apollo/client';
import GET_LOCALE from 'src/graphql/queries/intlQuery';

const SparkingUpYourCoaching = () => {
    const intl = useIntl();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [iframeSrc, setIframeSrc] = useState<string>('');

    const { data: locale } = useQuery(GET_LOCALE);

    useEffect(() => {
        document.title = intl.formatMessage({ id: 'LP_SPARKING_UP_YOUR_COACHING', defaultMessage: 'Sparking Up Your Coaching' });
    }, [intl]);

    useEffect(() => {
        const localeCode = sparkUpLanguageUrl(locale.appLocale);
        setIframeSrc(`${env.appUrl}/sparking-up-your-coaching${localeCode}/index.html`);
    }, [locale]);

    return (
        <MainLayout isHideSidebar={true}>
            {iframeSrc
            && <iframe
                src={iframeSrc}
                id='storyline'
                title='e-learningframe'
                className='pointer-events-auto w-screen absolute overflow-hidden'
                allowFullScreen
                style={{
                    height: '88%',
                }}
                ref={iframeRef}
            />
            }
        </MainLayout>
    );
};

export default SparkingUpYourCoaching;